export const templatesExceptions = {
  fetchAllTemplates: "Error al obtener las plantillas",
  getTemplatesNotInFolder:
    "Error al obtener las plantillas que no están en el expediente",
  addTemplatesToFolder: "Error al añadir las plantillas al expediente",
  fetchTemplateByID: "Error al obtener la plantilla con determinado id",
};
